<template>
  <div style="border-bottom: 1px solid black">
    <v-flex xs12 md px-4 mt-3>
      <v-layout column align-content-center justify-center fill-height>
        <v-layout row wrap>
          <v-flex xs12 md7 px-2>
            <v-text-field name="name" label="Name" box v-model="name"></v-text-field>
          </v-flex>
          <v-flex xs6 md2 lg1 px-2>
            <v-text-field name="age" label="age" box value  v-model="age"></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg3 px-2>
            <v-text-field name="school" label="School" box value v-model="school"></v-text-field>
          </v-flex>
          <v-flex xs6 md2 lg1 px-2>
            <v-text-field name="grade" label="grade" box value v-model="grade"></v-text-field>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </div>
</template>


<script>
export default {
  props: {
    order: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {
    name: {
      get() {
        return this.$store.state.registration.siblings["sibling_" + this.order]
          .name;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/siblings/setName", payload);
      }
    },
    age: {
      get() {
        return this.$store.state.registration.siblings["sibling_" + this.order]
          .age;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/siblings/setAge", payload);
      }
    },
    school: {
      get() {
        return this.$store.state.registration.siblings["sibling_" + this.order]
          .school;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/siblings/setSchool", payload);
      }
    },
    grade: {
      get() {
        return this.$store.state.registration.siblings["sibling_" + this.order]
          .grade;
      },
      set(value) {
        const payload = {
          num: this.order,
          value: value
        };
        this.$store.commit("registration/siblings/setGrade", payload);
      }
    }
  }
};
</script>
